<template>
	<div id="page">
		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<button @click.prevent="goBack">
						<i class="fa fa-arrow-right"></i>
					</button>نمایش موقعیت ها در نقشه
					<button data-menu="HelpMenu" class="position-static mr-2"><i class="fa fa-question-circle helpIco"></i></button>
				</h2>
				<button class="
            bg-fade-gray1-dark
            shadow-xl
            d-flex
            align-items-center
            justify-content-center
            refresh-btn
          "
						@click.prevent="reloadPage">
					<i class="font-16 fa fa-redo"></i>
				</button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="150">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
				<div class="card-bg bg-20"></div>
			</div>
			<div class="card card-style mb-2 overflow-visible">
				<div class="row m-0 p-3">
					<div class="col-6 pr-0 pl-1">
						<div class="btn-group btn-group-sm w-100" role="group" aria-label="Button group with nested dropdown">
							<v-select class="w-100" dir="rtl" label="title" placeholder="انتخاب کاربر" :filterable="localUserListList.length > 10" :searchable="localUserListList.length > 10" :options="localUserListList" :reduce="(p) => p.userId" v-model="userId" @option:selected="GetDateList">
								<template slot="option">
									<div class="d-center">
										{{ option.title }}
									</div>
								</template>
							</v-select>
						</div>
					</div>
					<div class="col-6 pr-0 pl-1">
						<div class="btn-group btn-group-sm w-100" role="group" aria-label="Button group with nested dropdown">
							<v-select class="w-100" dir="rtl" label="title" placeholder="تاریخ" :filterable="DateList.length > 10" :searchable="DateList.length > 10" :options="DateList" v-model="presenceDate" @option:selected="GetList">
								<template slot="option">
									<div class="d-center">
										{{ option }}
									</div>
								</template>
							</v-select>
						</div>
					</div>
				</div>
			</div>
			<div class="card card-style">
				<div class="content mb-0">
					<div class="mb-4">
						<div id="container">
							<div id="mapContainer" @click="handleClickDetailsButton" v-show="showDetailsModal==false"></div>
						</div>
					</div>
					<div v-if="selectedItem != null">
						<p>عنوان : {{ selectedItem.title }}</p>
						<p v-if="selectedItem.description != null">
							توضیحات : {{ selectedItem.description }}
						</p>
						<p v-if="selectedItem.address != null">
							آدرس : {{ selectedItem.address }}
						</p>
					</div>
				</div>
			</div>
		</div>


		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10">
					<i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...
				</div>
			</div>
		</transition>
		<transition name="modal" enter-active-class="animated fadeIn" appear>
			<div v-if="showDetailsModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container">
						<div class="modal-body m-0">
							<slot name="body">
								<edit-user-presence :showInModal="'1'" :selectedUserPrecenceId="selectedItemId" @close="showDetailsModal=false"></edit-user-presence>
							</slot>
						</div>
						<div class="modal-footer py-1 px-2">
							<slot name="footer">
								<button class="btn btn-xxs rounded-s bg-red1-light" @click="showDetailsModal=false">
									<i class="fa fa-times ml-2"></i>
									بستن
								</button>
							</slot>
						</div>
					</div>
				</div>
			</div>
		</transition>
		<Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
		<!--<div id="showUserOnMapHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">
						<div class="page-title page-title-small">
							<h2 class="text-center">معرفی موبایل اپلیکیشن تسکینو</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>

					<div class="card-bg bg-20"></div>
				</div>
				<div class="card card-style">
					<div class="content mt-0 pb-2">
						<div class="list-group list-custom-small list-icon-0 mt-3 border-b">
							<div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
								<i class="fa font-14 fa-info-circle color-magenta1-light"></i>
								<span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
								<i class="fa fa-angle-down line-height-xl"></i>
							</div>
						</div>
						<div class="collapse border-b pb-3" id="collapse-0" style="">
							<div class="d-flex justify-content-center">
								<video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
									<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-showUsersonMap.mp4" type="video/mp4">
								</video>
							</div>
							<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-showUsersonMap.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
						</div>
					</div>
				</div>
			</div>
		</div>-->
	</div>
</template>


<script>
	import "vue-select/dist/vue-select.css";
	import editUserPresence from '../UserPresence/EditUserPresence.vue';
    import HelpMenu from '../Components/HelpMenu.vue';
	import "leaflet/dist/leaflet.css";
	import { Geolocation } from "@capacitor/geolocation";
	import L from "leaflet";
	import "leaflet-polylinedecorator";
	const token =
		"pk.eyJ1IjoiZmhrYXplbWkiLCJhIjoiY2s5aGhwb3kxMDAxZTNsbHF2cWk0OXNpaiJ9.XyjH4-d0c05NOcyoZL-2tg";

	import Snap from "snapsvg-cjs";
	import "leaflet.bezier";
	export default {
		components: {
			"edit-user-presence": editUserPresence,
            "Help-Menu": HelpMenu
			// LMap,
			// LTileLayer,
			// LPolyline,
			// LMarker,
			// LPopup
		},

		data() {
			return {
				attInProgress: false,
				modified: false,
				showDetailsModal: false,
				mapLocationObject: null,
				url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
				attribution:
					'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
				presenceDate: null,
				page: 1,
				filterId: 0,
				searchKey: "",
				selectedItem: null,
				selectedItemId: 0,
				pageLoaded: false,
				userId: null,
				mapDiv: null,
				DateList: [],
				UserPresenceList: [{ lat: 35.715298, lng: 51.404343 }],
			};
		},
		computed: {
			Loading() {
				return this.$store.getters.GetLoading;
			},
			localUserListList() {
				return this.$store.getters.GetLocalUserListList;
			},

			PolyLine() {
				var list = this.UserPresenceList;
				var latLongArr = [];
				if (list != null) {
					console.log(list);
					console.log(list[0]);
					for (let index = 0; index < list.length; index++) {
						var m = list[index].mapLocation.split(",");
						var el = { lat: +m[0], lng: +m[1] };
						latLongArr.push(el);
					}
				}

				return {
					latlngs: latLongArr,
					color: "green",
				};
			},
		},
		created() {
			this.$store.dispatch("GetLocalUserListListFromServerForMap", {
				workGroupId: null,
			});
		},
		async mounted() {
			await this.GetList();
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");

		},
		watch: {
			presenceDate: {
				deep: true,
				async handler(value) {
					this.GetList();
				}
			}
		},
		methods: {
			async GetList() {
				if (this.userId == null || this.presenceDate == null) {
					document.getElementById('mapContainer').innerHTML = "<div class='text-center'><i class='fa fa-exclamation-triangle text-warning fa-3x'></i></div><p class='text-center py-3'>لطفا کاربر و تاریخ را وارد کنید.</p>";
					return;
				}
				var uId = "";
				var dt = "";
				if (this.userId != null) {
					uId = this.userId;
				}
				if (this.presenceDate != null) {
					dt = this.presenceDate;
				}
				this.$http.get("UserPresence/GetUserPresenceListForMap?date=" + dt + "&userId=" + uId)
					.then((data) => {
						if (data.data.length == 0) {
							document.getElementById('mapContainer').innerHTML = "<div class='text-center'><i class='fa fa-exclamation-triangle text-danger fa-3x'></i></div><p class='text-center py-3'>موقعیت کاربر در این تاریخ ثبت نشده است.</p>";
							return;
						}
						console.log("p list:");
						console.log(data.data);
						this.UserPresenceList = data.data;
						if (this.mapDiv == null) {
							this.intiateMap();
						}
						this.setupLeafletMap();
					});
			},

			GetDateList() {
				var uId = "";
				if (this.userId != null) {
					uId = this.userId;
				}
				this.$http.get("UserPresence/GetDateListForUser?userId=" + uId)
					.then((data) => {

						this.DateList = data.data;
						if (data.data.length == 0) {
							document.getElementById('mapContainer').innerHTML = "<div class='text-center'><i class='fa fa-exclamation-triangle text-danger fa-3x'></i></div><p class='text-center py-3'>موقعیتی برای این کاربر ثبت نشده است.</p>";
							return;
						}

						this.GetList();
					});
			},
			CreateUserPresence() {
				this.v$.$touch(); //it will validate all fields
				if (!this.v$.$invalid) {
					//invalid, becomes true when a validations return false
					this.modified = false;
					this.$store.dispatch("CreateUserPresence", this.userPresenceModel);
					this.modified = false;
				}
			},
			async intiateMap() {
				console.log("dsd");
			},
			async setupLeafletMap() {

				if (this.mapDiv != null) {
					this.mapDiv.remove();
				}

				document.getElementById('mapContainer').innerHTML = "";

				this.mapDiv = L.map("mapContainer").setView(
					this.PolyLine.latlngs[0],
					15
				);

				//this.mapDiv.options.maxZoom = 19;

				L.tileLayer(
					`https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png`,
					{
						//maxZoom: 22,
						maxNativeZoom: 19,
						accessToken: `${token}`,
					}
				).addTo(this.mapDiv);


				var mapDiv = this.mapDiv;
				for (var i in mapDiv._layers) {
					if (mapDiv._layers[i]._path != undefined) {
						try {
							mapDiv.removeLayer(mapDiv._layers[i]);
						} catch (e) {
							console.log("problem with " + e + mapDiv._layers[i]);
						}
					}
				}
				var polylinePoints = this.PolyLine.latlngs;
				// var polyline = L.polyline(polylinePoints).addTo(mapDiv);
				var options = {
					color: 'rgb(145, 146, 150)',
					fillColor: 'rgb(145, 146, 150)',
					dashArray: 8,
					opacity: 1,
					weight: '2',
					iconTravelLength: 0.5, //How far icon should go. 0.5 = 50%
					iconMaxWidth: 30,
					iconMaxHeight: 30,
					fullAnimatedTime: 5000,// animation time in ms
					easeOutPiece: 4, // animation easy ou time in ms
					easeOutTime: 2500, // animation easy ou time in ms
				};
				console.log("polylinePoints");

				console.log(polylinePoints);
				L.bezier({
					path: [
						polylinePoints,
					],

					icon: {
						path: "plane.png"
					}
				}, options).addTo(mapDiv);

				// var decorator = L.polylineDecorator(polyline, {
				//   patterns: [
				//     // defines a pattern of 10px-wide dashes, repeated every 20px on the line
				//     {
				//       offset: 0,
				//       repeat: 20,
				//       symbol: L.Symbol.arrowHead({
				//         pixelSize: 6,
				//         polygon: true,
				//         pathOptions: { stroke: true },
				//       }),
				//     },
				//   ],
				// }).addTo(mapDiv);


				mapDiv.fitBounds(polylinePoints);
				for (let index = 0; index < this.PolyLine.latlngs.length; index++) {
					var cloudIcon = L.divIcon({
						html: index + 1,
						className: "my-custom-icons",
						iconSize: [24, 24],
						iconAnchor: [24 / 2, 24],
					});
					var marker = L.marker(this.PolyLine.latlngs[index], { icon: cloudIcon }).addTo(
						mapDiv
					);
					var poupText = "<span class='spanDetails'><i class='fa fa-clock color-green2-dark ml-2'></i><b>ساعت: </b>" + this.UserPresenceList[index].createDateTime + "</span><br/><b class='spanDetails'><i class='fa fa-check-square color-green2-light ml-2'></i>" + this.UserPresenceList[index].title + "</b>";
					if (this.UserPresenceList[index].address != null) {
						poupText = poupText + "<br/><span class='spanDetails mb-2'><i class='fa fa-map-marker-alt color-green1-dark ml-2'></i><b>آدرس: </b>" + this.UserPresenceList[index].address + "</span>"
					}
					if (this.UserPresenceList[index].description != null && this.UserPresenceList[index].description.length > 0) {
						poupText = poupText + "<br/><span class='spanDetails mb-2'><i class='fa fa-edit color-green1-light ml-2'></i><b>توضیحات: </b>" + this.UserPresenceList[index].description + "</span>"
					}
					poupText = poupText + "<br/><button class='item-details btn btn-xxs mt-2 btn-full bg-green1-dark rounded-sm font-900 w-100' data-itemid='" + this.UserPresenceList[index].userPresenceId + "'><i class='fa fa-search ml-2'></i>جزییات بیشتر</button>"
					marker.bindPopup(poupText, {
						closeButton: false,
						className: "popUpDiv",
						maxWidth: 220,
					});
				}


			},
			checkLocation() {
				window.plugins.locationAccuracy.canRequest(function (canRequest) {
					if (canRequest) {
						window.plugins.locationAccuracy.request(
							function (success) {
								console.log(
									"Successfully requested accuracy: " + success.message
								);
							},
							function (error) {
								console.error(
									"Accuracy request failed: error code=" +
									error.code +
									"; error message=" +
									error.message
								);
								if (
									error.code !==
									window.plugins.locationAccuracy.ERROR_USER_DISAGREED
								) {
									if (
										window.confirm(
											"Failed to automatically set Location Mode to 'High Accuracy'. Would you like to switch to the Location Settings page and do this manually?"
										)
									) {
										window.plugins.diagnostic.switchToLocationSettings();
									}
								}
							},
							window.plugins.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY
						);
					} else {
						// request location permission and try again
					}
				});
			},

			getServerDateTime() {
				this.$http.get("Task/GetServerDateTime").then((data) => {
					this.userPresenceModel.presenceDate = data.data.split("_")[0];
					this.userPresenceModel.createDateTime = data.data.replace("_", " ");
				});
			},
			async getCurrentPosition() {
				try {
					const coordinates = await Geolocation.getCurrentPosition({
						enableHighAccuracy: true,
					});
					console.log(coordinates.coords.latitude);
				} catch (ex) {
					console.log(ex);
					this.showErrorMessage(
						"خطا در دریافت موقعیت مکانی. لطفا از روشن بودن Location دستگاه خود مطمئن شوید و مجددا تلاش کنید."
					);
				}
			},
			handleClickDetailsButton(e) {
				const elt = e.target.closest(".item-details");
				if (elt) {
					this.selectedItemId = elt.dataset.itemid;
					this.showDetailsModal = true;
				}
			},

			setTitle() {
				if (this.userPresenceModel.userPresenceTypeId == 1) {
					this.userPresenceModel.title = "ورود";
				} else if (this.userPresenceModel.userPresenceTypeId == 2) {
					this.userPresenceModel.title = "خروج";
				} else {
					this.userPresenceModel.title = "";
				}
			},
			showLocationDetails(obj) {
				this.selectedItem = obj;
			},
			pauseVid(id) {
				console.log(id);
				if (id != null) {
					console.log("pause");
					var vid = document.getElementById(id);
					vid.pause();
				}
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
		},
	

	};
</script>
<style scoped>
	#mapContainer {
		width: 100%;
		height: 400px;
		font-family: 'IRANSansWeb-FaNum' !important;
	}

		#mapContainer > > > .my-custom-icons {
			background-color: rgb(72, 0, 255);
			border-radius: 50%;
			padding: 5px;
			text-align: center;
			color: azure;
			font-weight: bolder;
		}

	.arrow-icon {
		width: 14px;
		height: 14px;
	}

		.arrow-icon > div {
			margin-left: -1px;
			margin-top: -3px;
			transform-origin: center center;
		}

	.spanDetails {
		float: right !important;
		direction: rtl !important;
	}

	.item-details {
		width: 80px;
		height: 50px;
	}

	.popUpDiv .leaflet-popup-content-wrapper {
		background: white !important;
		box-shadow: 0 3px 14px rgba(0,0,0,0.4) !important;
		border-radius: 0.3em;
		direction: rtl !important;
		display: flex;
		justify-content: center;
	}

	.popUpDiv {
		background: white !important;
		box-shadow: 0 3px 14px rgba(0,0,0,0.4) !important;
		border-radius: 0.3em;
		direction: rtl !important;
	}
	
</style>